import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isEqual } from "lodash";
import React, { memo } from "react";
import ReactTooltip from "react-tooltip";
import { KEY_ENTER, KEY_SPACE, TOOLTIP_SHOW_DELAY } from "@config/constants";
var NextButton = function(param) {
    var disabled = param.disabled, getButtonsData = param.getButtonsData, onClick = param.onClick;
    var onKeyDownHandler = function(e) {
        var key = e.which;
        if (key === KEY_SPACE || key === KEY_ENTER) {
            onClick();
            e.stopPropagation();
        }
    };
    var buttonsData = getButtonsData();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ReactTooltip, {
                id: "next-button-tooltip",
                className: "tooltip",
                place: "bottom",
                delayShow: TOOLTIP_SHOW_DELAY,
                disable: disabled,
                effect: "solid",
                getContent: [
                    function() {
                        return buttonsData.next.dataTip;
                    }
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "play-button player-button",
                onClick: onClick,
                onKeyDown: onKeyDownHandler,
                tabIndex: "0",
                "data-for": "next-button-tooltip",
                "data-tip": buttonsData.next.dataTip,
                children: /*#__PURE__*/ _jsx("span", {
                    className: "icon icon-skip-next pointer"
                })
            })
        ]
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(NextButton, areEqual);
